/**
 * @file Utils of all the generic helper functions
 * @author Alwyn Tan
 */

/**
 * converts array of objects to objects
 * Requirements: must have "id" as a unique key
 * Eg: [{id: 1, value: 'test'}] -> {1: {value: 'test'}}
 * @param {Array} arr Array of Objects
 */
export const normalizeArrayOfObjects = arr => {
  return arr.reduce((acc, curr) => ({ ...acc, [curr.id]: curr }), {})
}

/**
 *
 * @param {Array} arr Array of Objects
 * @param {Object} options Options
 * @param {String} options.normalizeBy defaults to id. Choose which field to normalize arrays by
 * @returns
 */
export const normalizeObjectArray = (arr, options = { normalizeBy: 'id' }) => {
  return arr.reduce(
    (acc, curr) => ({
      normalized: { ...acc.normalized, [curr[options.normalizeBy]]: curr },
      ids: [...acc.ids, curr[options.normalizeBy]],
    }),
    { normalized: {}, ids: [] }
  )
}
